var deepMerge = require('../util/deep-merge');
var Events = require('../util/events');
var { throttle } = require('../util/debounce-throttle');
var storage = require('../util/flash-storage');

var Checkout = function(el, options) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = deepMerge({
    }, options || {});
    this.init();
};

Checkout.prototype = {
    constructor: Checkout,
    $el: undefined,
    $modal: undefined,
    events: undefined,
    awesomplete: undefined,
    awesompleteThrottle: undefined,
    isSubmitting: undefined,
    init: function() {
        var self = this;

        if (!self.$el.length) {
            return;
        }

        self.$modal = $('#standard-modal');

        // retrieve form data
        var existingData = self.retrieveFormData();
        if (existingData) {
            for (var key in existingData) {
                if (existingData.hasOwnProperty(key) && existingData[key]) {
                    switch (key) {
                        case 'checkout_existing':
                            $('#' + key).val(existingData[key]);
                            break;
                        case 'order_paid': 
                            $('[name="' + key + '"]').prop('checked', existingData[key]);
                            break;
                        default:
                            $('[name="' + key + '"]').val(existingData[key]);
                            break;
                    }
                }
            }
        }

        var awesompleteEl = document.querySelector('.awesomplete-existing');
        if (awesompleteEl) {
            self.awesompleteThrottle = throttle(function() {
                $.get('/admin/users/awesomplete?search=' + encodeURIComponent(awesompleteEl.value)).done(function(response) {
                    self.awesomplete.list = response.results;
                    self.awesomplete.evaluate();
                });
            }, 1000);
            self.awesomplete = new Awesomplete(awesompleteEl, {
                filter: function() { return true; },
                sort: false,
                list: []
            });
            awesompleteEl.addEventListener('keyup', function(evt) {
                if ([13, 37, 38, 39, 40].indexOf(evt.keyCode) === -1) {
                    self.awesompleteThrottle();
                }
            });
            awesompleteEl.addEventListener('awesomplete-selectcomplete', function(evt) {
                var id = parseInt(evt.text.value.match(/^\[(\d+)\]/)[1]);
                $('[name="existing_customer"]').val(id);
                $.get('/admin/users/details/' + id).done(function(response) {
                    if (response) {
                        var $firstname = $('#checkout_firstname'),
                            $lastname = $('#checkout_lastname'),
                            $email = $('#checkout_email'),
                            $phone = $('#checkout_phone'),
                            $address = $('#checkout_address'),
                            $address2 = $('#checkout_address_2'),
                            $city = $('#checkout_city'),
                            $state = $('#checkout_state'),
                            $zip = $('#checkout_zip_code');
                        $firstname.val(!$firstname.val() ? response.first_name : $firstname.val());
                        $lastname.val(!$lastname.val() ? response.last_name : $lastname.val());
                        $email.val(!$email.val() ? response.email : $email.val());
                        $phone.val(!$phone.val() ? self.formatPhoneNumber(response.phone) : $phone.val());
                        $address.val(!$address.val() ? response.address : $address.val());
                        $address2.val(!$address2.val() ? response.address_2 : $address2.val());
                        $city.val(!$city.val() ? response.city : $city.val());
                        $state.val(!$state.val() ? response.state : $state.val());
                        $zip.val(!$zip.val() ? response.zip_code : $zip.val());
                    }
                });
            });
        }

        $('#checkout_phone').on('blur', function(evt) {
            var $this = $(this);
            $this.val(self.formatPhoneNumber($this.val()));
        });

        var updateFinalTotal = function() {
            var $cakeDataInput = $('input[name="decorated_cakes"]'),
                cakeData = JSON.parse($cakeDataInput.val()),
                $totalLabel = $('.checkout-summary-final-total');

            var cakeTotal = 0.0;
            cakeData.forEach(function(cake) {
                cakeTotal += parseFloat(cake.price)
            });

            var total = (parseFloat($totalLabel.attr('data-total')) + cakeTotal).toFixed(2);
            $totalLabel.html(`$${total}`);
        };

        var loadDecoratedCakes = function() {
            var $cakeDataInput = $('input[name="decorated_cakes"]'),
                cakeData = JSON.parse($cakeDataInput.val()),
                $lineItemsContainer = $('.decorated-cake-lineitems');
            $lineItemsContainer.find('.decorated-cake-lineitem').remove();

            cakeData.forEach(function(cake, idx) {
                var formattedPrice = parseFloat(cake.price).toFixed(2)
                $lineItemsContainer.find('.col').append(
                    $(`<div class="d-flex flex-row justify-content-between mt-1 text-secondary decorated-cake-lineitem" data-index="${idx}">
                        <div>Decorated Cake (${cake.type})</div>
                        <div>$${formattedPrice}</div>
                    </div>`)
                );
            });
        };

        if ($('input[name="decorated_cakes"]').length) {
            // loadDecoratedCakes();
            updateFinalTotal();
        }

        // Disable payment requirements if using paylater
        $('.paylater-btn').on('click', function() {
            $('[name="card_name"],[name="card_number"],[name="card_exp_month"],[name="card_exp_year"],[name="card_cvv"]').prop('required', false);
        });

        $('.notes-btn').on('click', function() {
            self.openNotesModal();
        });

        // persist checkout form data
        $('.edit-button').on('click', function() {
            self.saveFormData();
        });

        if ($('[name="payment_type"]').length) {
            self.$modal.on('hidden.bs.modal', function() {
                $('[name="payment_type"]').prop('disabled', false);
            });
        }
        $('[name="payment_type"]').on('click', function(evt) {
            $('[name="payment_type"]').prop('disabled', true);
            self.openPrepaidModal();
            // $('form').submit();
        });

        $('form').on('submit', function(evt) {
            // Another way to ensure it can only be submitted once
            if (self.isSubmitting) {
                console.log('submit attempt blocked');
                evt.preventDefault();
                return false;
            }
            self.isSubmitting = true;
            console.log('isSubmitting set to true');
        });

        // on success clear cached form data
        if (window.location.search.match(/[?|&]success=true[&]?/)) {
            self.removeFormData();
        }
    },
    formatPhoneNumber: function(number) {
        var formatted = number,
            numbersOnly = number.replace(/[^0-9]/g, '');
        if (numbersOnly.length === 10) {
            numbersOnly.split('');
            formatted = '(' + numbersOnly.slice(0, 3) + ') ' + numbersOnly.slice(3, 6) + '-' + numbersOnly.slice(6, 10);
        }
        if (numbersOnly.length === 11) {
            numbersOnly.split('');
            formatted = '+' + numbersOnly[0] + ' (' + numbersOnly.slice(1, 4) + ') ' + numbersOnly.slice(4, 7) + '-' + numbersOnly.slice(7, 11);
        }
        return formatted;
    },
    openNotesModal: function() {
        var self = this,
            modal = bootstrap.Modal.getOrCreateInstance(self.$modal[0]);

        // modal setup
        if (!self.$modal.find('.modal-body .notes-content').length) {
            self.$modal.find('.prepaid-content').hide();

            self.$modal.find('.modal-header .btn-close').show();

            // textarea
            var div = $('<div class="notes-content"></div>');
            div.append('<textarea class="form-control"></textarea>');
            self.$modal.find('.modal-body').append(div);
            self.$modal.find('.modal-body .notes-content textarea').val($('[name="notes"]').val());
            self.$modal.find('.modal-body .notes-content textarea').on('change', function() {
                $('[name="notes"]').val($(this).val());
            });

            // header
            self.$modal.find('.modal-header h5').append('<span class="notes-content">Order Notes</span>');

            // close button
            self.$modal.find('.modal-footer').append('<button type="button" class="btn btn-primary notes-content" data-bs-dismiss="modal">Save</button>');
        }
        else {
            self.$modal.find('.notes-content').show();
        }

        modal.show();
    },
    openPrepaidModal: function() {
        var self = this,
            modal = bootstrap.Modal.getOrCreateInstance(self.$modal[0]);

        if (!self.$modal.find('.modal-body .prepaid-content').length) {
            self.$modal.find('.notes-content').hide();
            // self.$modal.find('.modal-header .btn-close').hide();

            var div = $('<div class="prepaid-content"></div>');
            div.append('<h4>Is this order prepaid?</h4>');
            self.$modal.find('.modal-body').append(div);
            
            var $noBtn = $('<button type="button" class="btn btn-danger prepaid-content" data-bs-dismiss="modal">No</button>');
            var $yesBtn = $('<button type="button" class="btn btn-success prepaid-content" data-bs-dismiss="modal">Yes</button>');
            $noBtn.on('click', function() {
                $('[name="order_paid"]').prop('checked', false);
                setTimeout(function() {
                    $('form').submit();
                }, 1);
            });
            $yesBtn.on('click', function() {
                $('[name="order_paid"]').prop('checked', true);
                setTimeout(function() {
                    $('form').submit();
                }, 1);
            });
            self.$modal.find('.modal-footer').append($noBtn);
            self.$modal.find('.modal-footer').append($yesBtn);

            // header
            self.$modal.find('.modal-header h5').append('<span class="prepaid-content">Order Prepaid</span>');
        }
        else {
            self.$modal.find('.prepaid-content').show();
        }

        modal.show();
    },
    saveFormData: function(data) {
        var data = {
            checkout_existing: $('#checkout_existing').val(),
            existing_customer: $('[name="existing_customer"]').val(),
            first_name: $('[name="first_name"]').val(),
            last_name: $('[name="last_name"]').val(),
            phone: $('[name="phone"]').val(),
            email: $('[name="email"]').val(),
            taker_initials: $('[name="taker_initials"]').val(),
            order_paid: $('[name="order_paid"]').prop('checked') ? true : false,
            notes: $('[name="notes"]').val()
        };
        if (localStorage) {
            localStorage.setItem('checkoutForm', JSON.stringify(data));
        }
    },
    retrieveFormData: function() {
        if (localStorage) {
            var data = localStorage.getItem('checkoutForm') || null;
            return data ? JSON.parse(data) : null;
        }
        return null;
    },
    removeFormData: function() {
        localStorage.removeItem('checkoutForm');
    }
};

window.addEventListener('load', function() {
    var checkout = document.querySelector('.checkout-container');
    if (checkout) {
        var m = new Checkout(checkout);
    }

    // clear storage on success page
    if (document.querySelector('.checkout-success-container') && window.location.search.match(/success\=true/)) {
        storage.removeItem('items');
        storage.wipeData();
    }
});

module.exports = Checkout;